@import '../general';
@import 'button';
@import '@db-ui/core/sources/_patterns/00-base/icons/icons.helpers';

:host[disabled] {
  pointer-events: none;
}

// Enabling to hide text next to the icon (the DB UI Core selector is differently, as we're using the DBIcon component here internally)
button.is-icon-text-replace {
  @include is-icon-text-replace();

  aspect-ratio: 1;
}

db-icon {
  .is-icon-text-replace & {
    --icon-margin-after: 0;
  }

  &.iconafter {
    --icon-margin-after: 0;

    margin-inline-start: 0.375rem;
  }
}
